import iconTracking from "assets/img/icon-tracking.svg"
import AssetTrackingModal from "components/AssetTrackingModal/AssetTrackingModal"

import { IMapMarkerProps, MapMarkerType } from "components/MapView/MapMarker/MapMarker"
import MapView, { IMapViewProps, MapViewControl } from "components/MapView/MapView"
import { TenantWarehouse } from "models/TenantWarehouse"
import { CSSProperties, FC, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { Guid } from "@/types"

interface ICurrentAssetLocationMapProps {
    height?: CSSProperties['height']
    homebaseWarehouse?: TenantWarehouse | null
    latitude: number
    longitude: number
    trackingAssetId?: Guid
}

const CurrentAssetLocationMap: FC<ICurrentAssetLocationMapProps> = ({
    height,
    homebaseWarehouse,
    latitude,
    longitude,
    trackingAssetId,
}) => {
    const { t } = useTranslation()
    const [showTrackingModal, setShowTrackingModal] = useState(false)

    const controls: IMapViewProps['controls'] = [
        MapViewControl.type,
        MapViewControl.zoom,
    ]

    if (trackingAssetId) {
        controls.push({
            position: "right-bottom",
            icon: iconTracking,
            title: t('asset.assetTracking'),
            onClick: () => setShowTrackingModal(true),
        })
    }

    const mapMarkers = useMemo<IMapMarkerProps[]>(() => {
        return [
            ...homebaseWarehouse ? [{
                coordinates: {
                    lat: homebaseWarehouse.location.lat,
                    lng: homebaseWarehouse.location.lng,
                },
                type: MapMarkerType.house,
                title: homebaseWarehouse.description,
            }] : [],
            {
                coordinates: {
                    lat: latitude,
                    lng: longitude,
                }
            },
        ]
    }, [homebaseWarehouse, latitude, longitude])


    return (
        <>
            <div style={{ height }}>
                <MapView
                    markers={mapMarkers}
                    autoCenterToMarkers
                    controls={controls}
                />
            </div>
            {!!trackingAssetId && showTrackingModal &&
                <AssetTrackingModal
                    assetId={trackingAssetId}
                    onClose={() => setShowTrackingModal(false)}
                />
            }
        </>
    )
}

export default CurrentAssetLocationMap
